export default "__VITE_ASSET__47f78da5__"